import {extend} from 'flarum/common/extend';
import PostControls from 'flarum/forum/utils/PostControls';
import CommentPost from 'flarum/forum/components/CommentPost';
import Button from "flarum/common/components/Button"

export default () => {

  extend(PostControls, 'moderationControls', function (items) {
    if (items.has('edit')) {
      items.remove('edit');
    }
  });

  extend(CommentPost.prototype, 'actionItems', function (items) {
    const post = this?.attrs?.post;

    if (post.canEdit()) {
      items.add('edit', <Button className="Button Button--link editpostbutton"
                        title={app.translator.trans('core.forum.post_controls.edit_button')}
                        onclick={PostControls.editAction.bind(post)}>{app.translator.trans('core.forum.post_controls.edit_button')}</Button>);
    }
  });
};
